import { ViewByToggleSchema } from "@redotech/redo-model/analytics/returns-claims/filters/view-by-toggle";
import * as z from "zod";

export const getProductBenchmark = {
  name: "getProductBenchmark" as const,
  input: z.object({
    productId: z.string().describe("The product ID to get benchmarks for"),
    startDate: z.string().describe("Start date for the analytics period"),
    endDate: z.string().describe("End date for the analytics period"),
    viewBy: ViewByToggleSchema.describe("Date type to filter by"),
  }),
  output: z
    .object({
      productCount: z
        .number()
        .describe("Number of similar products with analytics data"),
      avgReturnRate: z
        .number()
        .describe("Average return rate across similar products"),
      avgExchangeRate: z
        .number()
        .describe("Average exchange rate across similar products"),
      totalItemsSold: z
        .number()
        .describe("Total items sold across similar products"),
      totalItemsReturned: z
        .number()
        .describe("Total items returned across similar products"),
      categoryName: z
        .string()
        .nullish()
        .describe("Generated category name for similar products"),
    })
    .optional(),
};

export type ProductBenchmark = z.infer<typeof getProductBenchmark.output>;
